// extracted by mini-css-extract-plugin
module.exports = {"container":"Title_container__3Ysr8","center":"Title_center__1RaT3","leftAlign":"Title_leftAlign__11Ayg","title":"Title_title__1wjKC","subTitle":"Title_subTitle__7FWH-"};